import React, { useState } from "react"
import { makeStyles } from "@material-ui/styles"
import { ShippingInformation, CartModal } from ".."
import { injectIntl } from "react-intl"

const useStyles = makeStyles(theme => {
  return {
    checkoutContainer: {
      display: "flex",
      [theme.breakpoints.up("lg")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.down("md")]: {
        flexDirection: "column-reverse",
      },
    },
  }
})

export default injectIntl(props => {
  const classes = useStyles()
  const [showCart, setShowCart] = useState(false)
  return (
    <div className={classes.checkoutContainer}>
      <ShippingInformation
        header={props.header}
        footer={props.footer}
        checkout={props.checkout}
        reference={props.reference}
        showCart={showCart}
        bgImgLeft={props.bgImgLeft}
        bgImgRight={props.bgImgRight}
        langKey={props.langKey}
      />
      <CartModal
        header={props.header}
        isLoaderOpen={true}
        showCart={showCart}
        setShowCart={setShowCart}
        isCheckout={true}
        open={true}
        onClose={null}
        isModal={false}
        langKey={props.langKey}
      />
    </div>
  )
})
